import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...props }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
        {...props}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p className={`font-mono text-xs uppercase tracking-[0.25em] text-brand-amber ${className}`}>
        {children}
    </p>
);
